import { Link } from "react-router-dom";
import React, { useState, memo } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Field } from "react-final-form";
import { EyeIcon } from "../../../styles/img/svg/EyeIcon";

export const UiInput = memo((props) => {
    const [passwordType, setPasswordType] = useState("password");

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };

    return (
        <Field
            name={props.name}
            render={({ input, meta }) => {
                return (
                    <>
                        <div className="sb-input-wrapper">
                            <Form.Group controlId={props.id}>
                                {props.label && (
                                    <Form.Label>{props.label}</Form.Label>
                                )}

                                {props.inputhideicon ? (
                                    <Form.Control
                                        {...input}
                                        {...props}
                                        type={passwordType}
                                        name="password"
                                        placeholder={props.placeholder}
                                        isInvalid={
                                            meta.invalid &&
                                            meta.touched &&
                                            !meta.active
                                        }
                                        onChange={(e) => {
                                            input.onChange(e);
                                            if (props.onChange) {
                                                props.onChange(e);
                                            }
                                        }}
                                    />
                                ) : (
                                    <Form.Control
                                        type={props.type}
                                        placeholder={props.placeholder}
                                        isInvalid={
                                            meta.invalid &&
                                            meta.touched &&
                                            !meta.active
                                        }
                                        {...input}
                                        {...props}
                                        //  value={props.value}
                                        onChange={(e) => {
                                            input.onChange(e);
                                            if (props.onChange) {
                                                props.onChange(e);
                                            }
                                        }}
                                    />
                                )}

                                {!meta.error && (
                                    <>
                                        {props.inputhideicon && (
                                            <div
                                                onClick={togglePassword}
                                                className={
                                                    passwordType === "password"
                                                        ? ""
                                                        : "sb-input-wrapper__sb-view"
                                                }
                                            >
                                                <EyeIcon />
                                            </div>
                                        )}
                                    </>
                                )}
                                <Form.Control.Feedback type="invalid">
                                    {meta.error}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                    </>
                );
            }}
        />
    );
});

export const UiCheckboxInput = (props) => {
    return (
        <Field
            name={props.name}
            render={({ input, meta }) => {
                return (
                    <>
                        <div className="sb-radio-input-wrapper">
                            <Form.Group controlId={props.id}>
                                <Form.Check
                                    {...input}
                                    {...props}
                                    type={props.type}
                                    name={props.name}
                                    id={props.id}
                                    label={props.label}
                                    // onChange={props.onChange}
                                    isInvalid={
                                        meta.invalid &&
                                        meta.touched &&
                                        !meta.active
                                    }
                                    feedbackType="invalid"
                                    feedback={meta.error}
                                />

                                {/* {props.linkLabel && (
                                        <>
                                            <label
                                                htmlFor={props.for}
                                                className="sb-radio-input-wrapper__flex__label"
                                            >
                                                {props.linkLabel}
                                            </label>
                                        </>
                                    )} */}

                                {/* <Form.Control.Feedback type="invalid">
                                    {meta.error}
                                </Form.Control.Feedback> */}
                            </Form.Group>
                        </div>
                    </>
                );
            }}
        />
    );
};

export const UiInputDashBoard = (props) => {
    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState("");
    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    };
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };

    return (
        <>
            <Field
                name={props.name}
                render={({ input, meta }) => {
                    return (
                        <>
                            <div className="sb-input-wrapper">
                                <Form.Group controlId={props.id}>
                                    {props.label && (
                                        <Form.Label>{props.label}</Form.Label>
                                    )}

                                    {props.inputhideicon ? (
                                        <Form.Control
                                            type={passwordType}
                                            name="password"
                                            placeholder={props.placeholder}
                                        />
                                    ) : (
                                        <Form.Control
                                            {...input}
                                            {...props}
                                            isInvalid={
                                                meta.invalid &&
                                                meta.touched &&
                                                !meta.active
                                            }
                                            type={props.type}
                                            placeholder={props.placeholder}
                                            // value={props.value}
                                            onChange={(e) => {
                                                input.onChange(e);
                                                if (props.onChange) {
                                                    props.onChange(e);
                                                }
                                            }}
                                        />
                                    )}

                                    {/* {!props.error && (
                                        <>
                                            {props.inputhideicon && (
                                                <div
                                                    onClick={togglePassword}
                                                    className={
                                                        passwordType ===
                                                        "password"
                                                            ? ""
                                                            : "sb-input-wrapper__sb-view"
                                                    }
                                                >
                                                    <EyeIcon />
                                                </div>
                                            )}
                                        </>
                                    )} */}

                                    {meta.invalid &&
                                        meta.touched &&
                                        !meta.active && (
                                            <Form.Control.Feedback type="invalid">
                                                {meta.error}
                                            </Form.Control.Feedback>
                                        )}
                                </Form.Group>
                            </div>
                        </>
                    );
                }}
            />
        </>
    );
};

export const UiInputLink = (props) => {
    return (
        <>
            <div className="sb-input-link">
                <Link to={props.link}>{props.text}</Link>
            </div>
        </>
    );
};

export const UiCheckboxInputDefault = (props) => {
    return (
        <>
            <div className="sb-radio-input-wrapper">
                <div key={props.type} className="sb-radio-input-wrapper__flex">
                    <Form.Check
                        {...props}
                        type={props.type}
                        name={props.name}
                        id={props.id}
                        label={props.label}
                    />

                    {props.link && (
                        <>
                            <label
                                htmlFor={props.for}
                                className="sb-radio-input-wrapper__flex__label"
                            >
                                {props.linkLabel}
                                <Link to={props.to}>{props.link}</Link>
                            </label>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export const UiInputWithValues = (props) => {
    return (
        <Field
            name={props.name}
            render={({ input, meta }) => {
                return (
                    <>
                        <div className="sb-input-wrapper">
                            <Form.Group controlId={props.id}>
                                {props.label && (
                                    <Form.Label>{props.label}</Form.Label>
                                )}

                                <Form.Control
                                    type={props.type}
                                    placeholder={props.placeholder}
                                    isInvalid={
                                        meta.invalid &&
                                        meta.touched &&
                                        !meta.active
                                    }
                                    {...input}
                                    {...props}
                                    onChange={(e) => {
                                        input.onChange(e);
                                        if (props.onChange) {
                                            props.onChange(e);
                                        }
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {meta.error}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                    </>
                );
            }}
        />
    );
};
